module.exports = __webpack_public_path__ + "img/07251617000200.d38500cd.png";